import { useMutation } from 'platform/useMutation';
import { gql } from '@apollo/client';
import { useObservability } from 'shared/helpers/observability';

import {
  ScheduleOfferReviewMutation as ScheduleMutation,
  ScheduleOfferReviewMutationVariables as ScheduleVariables,
} from 'sellDirect/graphql/__generated__/ScheduleOfferReviewMutation';
import { getLeadInfo } from 'sellDirect/helpers/useCalendlyParams';
import { OdProtosCommonMarket_Market } from '__generated__/globalTypes';
import { useQualificationContext } from 'shared/helpers/QualificationContext';
import { ZonedDateTime } from '@js-joda/core';
import { ORVAData } from 'sellDirect/OfferContext';

export const ScheduleOfferReviewMutation = gql`
  mutation ScheduleOfferReviewMutation(
    $calendar: String!
    $startTime: String!
    $market: OdProtosCommonMarket_Market!
    $fullName: String!
    $phoneNumber: String!
    $email: String!
    $sellerInputUUID: String!
    $experimentEntityId: String
    $source: String
  ) {
    webCalendly {
      scheduleOfferReview(
        input: {
          calendar: $calendar
          startTime: $startTime
          market: $market
          fullName: $fullName
          phoneNumber: $phoneNumber
          email: $email
          sellerInputUuid: $sellerInputUUID
          experimentEntityId: $experimentEntityId
          source: $source
        }
      ) {
        result
      }
    }
  }
`;

/** TODO: Add documentation */
export const useScheduleOfferReview = (calendar: ORVAData['calendar']) => {
  const { lead, experimentEntityId, sellerInputUUID } = useQualificationContext();
  const { email, name } = getLeadInfo(lead);
  const market = lead?.address?.market?.toLowerCase() as string;
  const { trackError } = useObservability();
  const marketProto: OdProtosCommonMarket_Market = market
    ? OdProtosCommonMarket_Market[market?.toUpperCase() as OdProtosCommonMarket_Market]
    : OdProtosCommonMarket_Market.UNKNOWN;

  const [schedule, { data, loading, error }] = useMutation<ScheduleMutation, ScheduleVariables>(
    ScheduleOfferReviewMutation,
    {
      fetchPolicy: 'no-cache',
      onError: (error) => trackError('schedule-offer-review-mutation', error),
    },
  );

  const scheduleORVA = (phoneNumber: string, startTime: ZonedDateTime) => {
    if (!(calendar && name && email)) {
      const missingFields: string[] = [];

      !calendar && missingFields.push('calendar');
      !name && missingFields.push('name');
      !email && missingFields.push('email');

      trackError(`cannot-schedule-orva--missing-fields`, undefined, {
        leadId: lead?.id,
        missingFields: missingFields.join(', '),
      });
      return;
    }

    return schedule({
      variables: {
        calendar: calendar,
        startTime: startTime.toInstant().toString(),
        market: marketProto,
        fullName: name,
        phoneNumber,
        email,
        sellerInputUUID,
        experimentEntityId,
        source: 'cake',
      },
    });
  };

  return { scheduleORVA, loading, data, error };
};
